// extracted by mini-css-extract-plugin
export default {"avatar":"UserLogo_avatar__4YUGL","userlogo":"UserLogo_userlogo__wAsur","username":"UserLogo_username__WfpL4"};